// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResendVerificationCode_register__PCaFa {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 13px;
    color: #7e8b9e;
}

.ResendVerificationCode_register_link__t4gjO {
    color: #3568ff;
}

.ResendVerificationCode_register_link__t4gjO:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/components/ResendVerificationCode/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".register {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-size: 13px;\n    color: #7e8b9e;\n}\n\n.register_link {\n    color: #3568ff;\n}\n\n.register_link:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"register": `ResendVerificationCode_register__PCaFa`,
	"register_link": `ResendVerificationCode_register_link__t4gjO`
};
export default ___CSS_LOADER_EXPORT___;
